import { render, staticRenderFns } from "./ChannelStatusItem.vue?vue&type=template&id=deb70684&scoped=true"
import script from "./ChannelStatusItem.vue?vue&type=script&lang=js"
export * from "./ChannelStatusItem.vue?vue&type=script&lang=js"
import style0 from "./ChannelStatusItem.vue?vue&type=style&index=0&id=deb70684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb70684",
  null
  
)

export default component.exports